<template>
    <div class="margin-header">
        <TopBar :title="$vuetify.lang.t('$vuetify.PunchLogSecurityDetail.pageName')" />
        <div class="box-round display-height">
            <div class="box-content pt-0 px-0">
                <div class="px-7 mt-4 font-weight-bold text-sm d-flex">
                    <div @click="clickBack()" class="liff-line-font-lexendDeca">{{$vuetify.lang.t('$vuetify.PunchLogSecurityDetail.pageName')}}</div>
                    <div class="px-1">/</div>
                    <div class="font-roboto">{{name}}</div>
                </div>
                <div class="px-7 mt-4 d-flex">
                    <div class="flex-auto mr-2">
                        <v-text-field
                            class="custom-input-search search font-weight-bold"
                            hide-details="auto"
                            outlined
                            :placeholder="$vuetify.lang.t('$vuetify.PunchLogSecurityDetail.search.placeholder')"
                            v-model="textSearch"
                            @input="inputSearch()"
                        ></v-text-field>
                    </div>
                    <div class="pr-2">
                        <div class="width-item">
                            <CustomIconDatePicker v-model="date" @onChangeDate="inputSearch()" />
                        </div>
                    </div>
                    <div class="width-item">
                        <v-select
                            placeholder="- Leave Type -"
                            class="custom-ddl no-padding"
                            :items="items"
                            v-model="status"
                            outlined
                            @change="inputSearch()"
                        ></v-select>
                    </div>
                </div>
                <div class="d-flex flex-nowrap text-sm mt-4 line-liff-detail">
                    <v-col cols="6" class="px-0 py-0  pl-7 text-blue">
                        {{list.length}} {{$vuetify.lang.t('$vuetify.PunchLogSecurityDetail.times')}}</v-col>
                    <v-col cols="6" class="px-0 py-0  text-right pr-7 text-base-grey2">
                        {{textDate}}
                    </v-col>
                </div>
                <div class="d-flex flex-nowrap header-item mt-4 text-sm line-liff-header-table">
                    <v-col cols="8" class="px-0 py-2 pl-7">
                        {{$vuetify.lang.t('$vuetify.PunchLogSecurityDetail.header.detail')}}
                    </v-col>
                    <v-col cols="4" class="px-0 py-2  text-right pr-7">
                        {{$vuetify.lang.t('$vuetify.PunchLogSecurityDetail.header.temp')}}
                    </v-col>
                </div>
                <div class="line-liff-detail-table">
                  <div class="list-item" v-for="(v,i) of list" :key="i">
                       <div class="d-flex pt-0 pr-5 ">
                          <v-col cols="6" class="pb-1 pl-7">
                              <i class="fas fa-address-card mr-2 mb-1"></i>
                              <span>{{v.type}}</span>
                          </v-col>
                          <v-col cols="6" class="pb-1 text-right">{{v.temp}}</v-col>
                      </div>
                      <div class="d-flex pt-0 pr-5 pb-2">
                          <v-col cols="8" class=" pb-1 pl-7 pt-0 d-flex ">
                              <div>
                                <i class="fas fa-user mr-3 mb-1"></i>
                              </div>
                              <span class="text-truncate">{{v.name}}</span>
                          </v-col>
                          <v-col cols="4" class=" pb-1 text-right pt-0"><small>{{v.time}}</small></v-col>
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import TopBar from '@/components/Liff/Components/header/TopBar.vue'
import CustomIconDatePicker from '@/components/Liff/Components/Input/CustomIconDatePicker.vue'

export default {
    name: 'PunchLogSecurityDetail',
    components: {
        TopBar,
        CustomIconDatePicker
    },
    data: function () {
        return {
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_PUNCH_LOG_SECURITY,
            id: null,
            status: null,
            name: null,
            title: null,
            textSearch: null,
            date: null,
            list: [],
            items: []
        }
    },
    computed: {
        textDate: function () {
            const lang = localStorage.getItem('lang')
            const date = this.$dateUtil.formatDate(this.date)
            const [d, m, y] = date.split('/')
            const months = this.$dateUtil.months(lang)
            return `${d} ${months[parseInt(m) - 1]} ${y}`
        }
    },
    created: function () {
        this.id = this.$route.params.id
        this.date = moment().format('YYYY-MM-DD')
        this.name = this.$route.query.shortName
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
                const res = await this.axios.get('punchlog/type/options')
                this.items = res.data.data
                this.status = res.data.data[0].value
                await this.search()
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        clickBack: function () {
            this.$router.push('/liff/punch-log/security')
        },
        inputSearch: async function () {
            clearTimeout(this.delayTimer)
            this.delayTimer = setTimeout(this.search, 500)
        },
        search: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const params = {
                    lineId: this.lineUserId,
                    search: this.textSearch,
                    date: this.date,
                    type: this.status,
                    cameraId: this.id
                }
                const res = await this.axios.post('punchlogs/line/security/camera/high-temperature', params)
                if (res && res.data && res.data.status === 'ok') {
                    this.list = res.data.data
                }
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@/styles/color.scss';
    .flex-auto {
        flex: 1;
    };
    .width-item {
        width: 40px;
    }
    .border-top {
        border-top: 1px solid $base-grey4;
    }
    .custom-margin {
        margin-top: -10px;
    }
    .rounded {
        border-radius: 5px;
    }

    .header-item {
        margin-top: -5px;
        color: $base-grey2;
        background: #d9e4ed;
        font-size: 14px;
    }
    .list-item {
        padding: 5px 0;
        &:not(:last-child){
            border-bottom: 1px solid $base-grey4;
        }
        i {
            color: $base-grey;
        }
        span {
            color: $base-grey3;
        }
    }
    ::v-deep .v-list-item__content {
        .v-list-item__title {
            font-family: Roboto !important;
        }
    }
</style>
